var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.size,"height":_vm.size * 5 / 14,"viewBox":"0 0 14 5"}},[_c('g',[_c('path',{attrs:{"fill":_vm.color,"d":"M13.546.708H.454a.312.312 0 0 0-.311.311v2.962c0 .172.14.311.311.311h13.092c.172 0 .311-.14.311-.311V1.019a.312.312 0 0 0-.311-.311z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }